import { render, staticRenderFns } from "./QualificationData.vue?vue&type=template&id=baa28fb8&"
import script from "./QualificationData.vue?vue&type=script&lang=js&"
export * from "./QualificationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports